import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { mapStateToProps } from './mapStateToProps';
import { mapDispatchToProps } from './mapDispatchToProps';
import BookingSectionTimesGridWrapper from './BookingSectionTimesGridWrapper';
import { mockable } from '../../../../config/mockable';

const BookingSectionTimesGridWrapperConnected = (
    connect(mapStateToProps, mapDispatchToProps)(
        withRouter(
            BookingSectionTimesGridWrapper
        )
    )
);

const bookingSectionTimesGridWrapperResolver = () => BookingSectionTimesGridWrapperConnected;

const BookingSectionTimesGridWrapperMockable = mockable(bookingSectionTimesGridWrapperResolver);

export {
    bookingSectionTimesGridWrapperResolver,
    BookingSectionTimesGridWrapperMockable as default,
};
